
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-button',
    imports: [],
    templateUrl: './button.component.html',
    styleUrl: './button.component.scss'
})
export class ButtonComponent {
  @Input() title: string = '';
  @Input() classes: string = '';
  @Input() type: string = 'button';
  @Input() disabled: boolean = false;
  @Input() isLoading: boolean | null = false;
  @Input() variant: 'default' | 'outline' = 'default';

  public getButtonClass(): string {
    const baseClass = this.variant === 'outline' ? 'btn-outline' : 'button';
    return `${baseClass} ${this.isLoading ? 'is-loading' : ''} ${this.classes}`;
  }
}
